// import { useState, useEffect } from "react";
// import FileUploadModal from "./FileUploadModal";
// import { useNavigate } from 'react-router-dom';


// const CarouselLanding = ({ largeImages = [], smallImages = [] }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isFileUploadModalOpen, setFileUploadModalOpen] = useState(false);
//     const navigate = useNavigate();


//     // Auto-transition between slides
//     useEffect(() => {
//         const interval = setInterval(() => {
//             const totalImages = largeImages.length > 0 ? largeImages.length : smallImages.length;
//             setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
//         }, 5000); // Change slide every 5 seconds
//         return () => clearInterval(interval);
//     }, [largeImages.length, smallImages.length]);

//     const openFileUploadModal = () => setFileUploadModalOpen(true);
//     const closeFileUploadModal = () => setFileUploadModalOpen(false);

//     return (
//         <div className="relative w-full h-[60vh] lg:h-[80vh] overflow-hidden">
//             {/* Carousel for Large Screens */}
//             <div className="hidden lg:block">
//                 {largeImages.map((image, index) => (
//                     <div
//                         key={index}
//                         className={`absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ${currentIndex === index ? "opacity-100" : "opacity-0"}`}
//                         style={{ backgroundImage: `url(${image})` }}
//                     >
//                         <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center pl-6">
//                             {index === 0 && (
//                                 <div className="flex flex-col w-full max-w-xl text-white">
//                                     <h2 className="text-3xl lg:text-4xl font-semibold mb-4">
//                                         Unlock Your Career Potential with Us.
//                                     </h2>
//                                     <p className="text-lg mb-6">
//                                         From crafting a compelling CV to navigating the job market, we’re here to guide you every step of the way. Our personalized career coaching, targeted training, and expert job search assistance will help you land your dream job.
//                                     </p>
//                                     <button
//                                         className="bg-secondary text-white px-8 py-4 rounded-lg mt-4 max-w-xs z-10"
//                                         onClick={openFileUploadModal}
//                                     >
//                                         Upload Your CV
//                                     </button>
//                                 </div>
//                             )}
//                             {index === 1 && (
//                                 <div className="flex flex-col w-full max-w-xl text-white pl-6">
//                                     <h2 className="text-3xl lg:text-4xl font-semibold mb-4">
//                                         Elevate Your Business with Expert Solutions
//                                     </h2>
//                                     <p className="text-lg mb-6">
//                                         We provide tailored HR, Management, Strategic Consulting, and Corporate Training services to help your organization excel. Whether it's optimizing operations, achieving certifications, or empowering your team, we’ve got you covered.
//                                     </p>
//                                     <button
//                                         className="bg-secondary text-white px-8 py-4 rounded-lg mt-4 max-w-xs"
//                                         onClick={() => navigate('/contact')}
//                                     >
//                                         Inquire Now
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             {/* Carousel for Small Screens */}
//             <div className="lg:hidden">
//                 {smallImages.map((image, index) => (
//                     <div
//                         key={index}
//                         className={`absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ${currentIndex === index ? "opacity-100" : "opacity-0"}`}
//                         style={{ backgroundImage: `url(${image})` }}
//                     >
//                         <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-start text-white p-4 pl-6">
//                             {index === 0 && (
//                                 <div className="w-full">
//                                     <h2 className="text-2xl font-semibold mb-4">
//                                         Unlock Your Career Potential with Us.
//                                     </h2>
//                                     <p className="text-base mb-4">
//                                         From crafting a compelling CV to navigating the job market, we’re here to guide you every step of the way. Our personalized career coaching, targeted training, and expert job search assistance will help you land your dream job.
//                                     </p>
//                                     <button
//                                         className="bg-secondary text-white px-8 py-4 rounded mt-4 z-20 relative"
//                                         onClick={openFileUploadModal}
//                                     >
//                                         Upload Your CV
//                                     </button>
//                                 </div>
//                             )}
//                             {index === 1 && (
//                                 <div className="w-full">
//                                     <h2 className="text-2xl font-semibold mb-4">
//                                         Elevate Your Business with Expert Solutions
//                                     </h2>
//                                     <p className="text-base mb-4">
//                                         We offer tailored services in HR, Management, Strategic Consulting, and Corporate Training to help your business succeed.
//                                     </p>
//                                     <button
//                                         className="bg-secondary text-white px-8 py-4 rounded mt-4"
//                                         onClick={() => navigate('/contact')}
//                                     >
//                                         Inquire Now
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             {/* File Upload Modal */}
//             {isFileUploadModalOpen && (
//                 <FileUploadModal
//                     isOpen={isFileUploadModalOpen}
//                     onClose={closeFileUploadModal}
//                     className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50"
//                 />
//             )}
//         </div>
//     );
// };

// export default CarouselLanding;
import { useState, useEffect } from "react";
import FileUploadModal from "./FileUploadModal";
import { useNavigate } from 'react-router-dom';

const CarouselLanding = ({ largeImages = [], smallImages = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFileUploadModalOpen, setFileUploadModalOpen] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024); // Tailwind lg breakpoint
    const navigate = useNavigate();

    // Detect screen size changes
    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Auto-transition using appropriate image list
    useEffect(() => {
        const images = isLargeScreen ? largeImages : smallImages;
        if (images.length === 0) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isLargeScreen, largeImages, smallImages]);

    const openFileUploadModal = () => setFileUploadModalOpen(true);
    const closeFileUploadModal = () => setFileUploadModalOpen(false);

    return (
        <div className="relative w-full h-[60vh] lg:h-[80vh] overflow-hidden">
            {/* Carousel for Large Screens */}
            <div className="hidden lg:block">
                {largeImages.map((image, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 
                            ${currentIndex === index ? "opacity-100 pointer-events-auto z-10" : "opacity-0 pointer-events-none z-0"}`}
                        style={{ backgroundImage: `url(${image})` }}
                    >
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center pl-6">
                            {index === 0 && (
                                <div className="flex flex-col w-full max-w-xl text-white">
                                    <h2 className="text-3xl lg:text-4xl font-semibold mb-4">
                                        Unlock Your Career Potential with Us.
                                    </h2>
                                    <p className="text-lg mb-6">
                                        From crafting a compelling CV to navigating the job market, we’re here to guide you every step of the way. Our personalized career coaching, targeted training, and expert job search assistance will help you land your dream job.
                                    </p>
                                    <button
                                        className="bg-secondary text-white px-8 py-4 rounded-lg mt-4 max-w-xs z-10"
                                        onClick={openFileUploadModal}
                                    >
                                        Upload Your CV
                                    </button>
                                </div>
                            )}
                            {index === 1 && (
                                <div className="flex flex-col w-full max-w-xl text-white pl-6">
                                    <h2 className="text-3xl lg:text-4xl font-semibold mb-4">
                                        Elevate Your Business with Expert Solutions
                                    </h2>
                                    <p className="text-lg mb-6">
                                        We provide tailored HR, Management, Strategic Consulting, and Corporate Training services to help your organization excel. Whether it's optimizing operations, achieving certifications, or empowering your team, we’ve got you covered.
                                    </p>
                                    <button
                                        className="bg-secondary text-white px-8 py-4 rounded-lg mt-4 max-w-xs z-10"
                                        onClick={() => navigate('/contact')}
                                    >
                                        Inquire Now
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Carousel for Small Screens */}
            <div className="lg:hidden">
                {smallImages.map((image, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 
                            ${currentIndex === index ? "opacity-100 pointer-events-auto z-10" : "opacity-0 pointer-events-none z-0"}`}
                        style={{ backgroundImage: `url(${image})` }}
                    >
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-start text-white p-4 pl-6">
                            {index === 0 && (
                                <div className="w-full">
                                    <h2 className="text-2xl font-semibold mb-4">
                                        Unlock Your Career Potential with Us.
                                    </h2>
                                    <p className="text-base mb-4">
                                        From crafting a compelling CV to navigating the job market, we’re here to guide you every step of the way. Our personalized career coaching, targeted training, and expert job search assistance will help you land your dream job.
                                    </p>
                                    <button
                                        className="bg-secondary text-white px-8 py-4 rounded mt-4 z-20 relative"
                                        onClick={openFileUploadModal}
                                    >
                                        Upload Your CV
                                    </button>
                                </div>
                            )}
                            {index === 1 && (
                                <div className="w-full">
                                    <h2 className="text-2xl font-semibold mb-4">
                                        Elevate Your Business with Expert Solutions
                                    </h2>
                                    <p className="text-base mb-4">
                                        We offer tailored services in HR, Management, Strategic Consulting, and Corporate Training to help your business succeed.
                                    </p>
                                    <button
                                        className="bg-secondary text-white px-8 py-4 rounded mt-4 z-20 relative"
                                        onClick={() => navigate('/contact')}
                                    >
                                        Inquire Now
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* File Upload Modal */}
            {isFileUploadModalOpen && (
                <FileUploadModal
                    isOpen={isFileUploadModalOpen}
                    onClose={closeFileUploadModal}
                    className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50"
                />
            )}
        </div>
    );
};

export default CarouselLanding;
